import { createSelector } from 'reselect';

import * as Dashboard from 'types';

interface ITimezoneState {
  app: Dashboard.AppState;
}

export const timeZoneSelector = createSelector(
  (state: ITimezoneState) => state.app.timeZone,
  (timeZone) => timeZone
);
